export const FieldSkeleton = () => (
  <section className='flex flex-col'>
    <div className='h-4 bg-tertiary rounded-sm w-16 mb-2' />
    <div className='h-[46px] bg-tertiary rounded-md w-full' />
  </section>
);
